import { Message } from 'element-ui'
import { createFeedbackMessage } from './feedbackMessageFactory.cjs'

export default createFeedbackMessage(Message)
